export const phoneNumberRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
export const containsNumberRegex = /\d/;
export const containsLowerCaseLetterRegex = /[a-z]/;
export const containsUpperCaseLetterRegex = /[A-Z]/;